// Convert log lines with UTC ISO timestamps to the browser's local timezone.
// Handles new format: [2024-01-01T14:30:45Z] message
// Falls back gracefully for old format: [HH:MM:SS] message (labels them UTC)
export function formatLogLine(line) {
  const isoMatch = line.match(/^\[(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z)\]/);
  if (isoMatch) {
    const localTime = new Date(isoMatch[1]).toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    return line.replace(isoMatch[0], `[${localTime}]`);
  }
  // Old HH:MM:SS-only format — append UTC note so it's not mistaken for local time
  const legacyMatch = line.match(/^\[(\d{2}:\d{2}:\d{2})\]/);
  if (legacyMatch) {
    return line.replace(legacyMatch[0], `[${legacyMatch[1]} UTC]`);
  }
  return line;
}

// Format any ISO datetime string to local date + time.
export function formatDateTime(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  } catch {
    return '';
  }
}
